import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import MicroLoader from "./MicroLoader";
import UserBridge from "../bridges/UserBridge";
const ClientHeader = () => {
  const [signOutLoader, setSignOutLoader] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);
  const nav = useNavigate()

  const signOut = async () => {
    setSignOutLoader(true);
    const response = await UserBridge.logout();
    const result = await response.json();
    if (result.error) {
      setSignOutLoader(false);
      alert(`There was an error, please try again.`);
    } else {
      setSignOutLoader(false);
      window.location.replace(process.env.REACT_APP_FFNAW_URL)
    }
  };

  const toggleMenu = () => {
    menuOpen ? setMenuOpen(false) : setMenuOpen(true);
  };

  return (
    <>
      <nav className="providerHeader">
        <div className="desktop">
          <div className="left">
            <a href={process.env.REACT_APP_FFNAW_URL}>
              <img src="../../assets/watermark-alpha.png" />
            </a>
          </div>
          <div className="right">
            <Link to="/clients">Home</Link>
            <Link to="/clients/schedule">Schedule</Link>
            <Link to="/">Booking Page</Link>
            <button onClick={signOut}>
              {signOutLoader ? <MicroLoader /> : "Sign Out"}
            </button>
          </div>
        </div>
        <div className="mobile">
          <div className="left">
            <a href={process.env.REACT_APP_FFNAW_URL}>
              <img src="../../assets/watermark-alpha.png" />
            </a>
          </div>
          <div className="right">
            <button onClick={toggleMenu}>Menu</button>
          </div>
        </div>
      </nav>
      <div
        id="menu"
        className={
          menuOpen ? `mobileSlideOut menuOpen` : `mobileSlideOut menuClosed`
        }
        onClick={toggleMenu}
      >
        <label>Menu</label>
        <Link to="/clients">Home</Link>
        <Link to="/clients/schedule">Schedule</Link>
        <Link to="/">Booking Page</Link>
        <button onClick={signOut}>Log Out</button>
      </div>
    </>
  );
};

export default ClientHeader;
